import React from "react";
import { useHistory } from "react-router";
import { selectUser } from "modules/auth/redux/selectors";
import useNotificationActions from "modules/notification/hooks/useNotificationActions";
import { useI18n } from "i18n";
import { useSelector } from "react-redux";
import {
  selectCurrentEventCode,
  selectCurrentEventId,
} from "modules/event/selectors";
import useEventBlacklistActions from "./hooks/useEventBlacklistActions";

const EventBlacklistSubscriber = () => {
  const history = useHistory();
  const { addInfoNotification } = useNotificationActions();
  const eventCode = useSelector(selectCurrentEventCode);
  const eventId = useSelector(selectCurrentEventId);
  const user = useSelector(selectUser);
  const { t } = useI18n();

  const { subscribe, unsubscribe } = useEventBlacklistActions();
  const handleBlacklisted = React.useCallback(() => {
    if (eventCode) {
      history.push(`/e/${eventCode}/register`);
      addInfoNotification({
        message: t("event.blacklist.message"),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventCode]);

  // eslint-disable-next-line consistent-return
  React.useEffect(() => {
    if (eventId && user) {
      subscribe(eventId, user.id, handleBlacklisted);

      return () => {
        unsubscribe();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId, user?.id]);

  return null;
};

export default EventBlacklistSubscriber;
